import Format from ".";

export type Options = {
  currencyUnits?: string;
  negate?: boolean;
  decimalPlaces?: number;
  suffix?: string;
  prefix?: string;
  hidden?: boolean;
  type?: Type;
  abbreviate?: boolean;
  styleVariation?: string;
};

export type FormattingMap = (value) => { value: Array<any>, formatOptions?: Format.Options };

export enum Type {
  Currency = "currency",
  PlainText = "plain text",
  Percentage = "percentage",
  Number = "number",
  PhoneNumber = "phoneNumber",
}
